export const guidePaths = {
  "/guides/switch-from-playwaze": "switch-from-playwaze",
  "/guides/switch-from-spond": "switch-from-spond",
  "/guides/badminton-pegboard": "badminton-pegboard",
  "/guides/switch-from-justgo-to-shuttleops": "switch-from-justgo-to-shuttleops",
  "/guides/first-club-session": "first-club-session",
  "/guides/badminton-club-management-software": "badminton-club-management-software",
  "/guides/collect-badminton-club-payments": "collect-badminton-club-payments"
};
export const guidePathForSlug = slug => Object.keys(guidePaths).find(path => guidePaths[path] === slug);
